<template lang="">
    <div class="modal fade" :id="modalId" ref="modalEl" tabindex="-1"  :aria-labelledby="`${modalId}-label`" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title" :id="`${modalId}-label`">{{ title }}</div>
          <button class="btn btn-default btn-sm close-btn" @click="handleClose">
            <CloseIcon/>
          </button>
      </div>
      <div class="modal-body" v-html="body">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-sm" style="color:white;background:var(--tertiary)" @click="handleClose">{{ buttonLabel || "Close" }}</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { Modal } from 'bootstrap';
import CloseIcon from '../IconComponents/CloseIcon.vue';
export default {
  components:{
    CloseIcon
  },
    props:{
        closeModal:{
            type: Function,
            required: true            
        },
        title:{
            type: String,
            required: true
        },
        body:{
            type: String,
            required: true
        },
        buttonLabel:{
          type:String
        },
        modalId:{
            type: String,
            required: true
        }
    },
     mounted() {
    this.modalInstance = new Modal(this.$refs.modalEl);
  },
    methods: {
      show() {
        this.modalInstance?.show();
      },
      hide() {
        this.modalInstance?.hide();
      }
      ,
      handleClose() {
        // Ensure the modal hides itself first, then call the parent's close handler
        this.hide();
        if (typeof this.closeModal === 'function') {
          this.closeModal();
        }
      }
    }


}
</script>
<style scoped>

  /* MODAL */
    .modal-body{
        color:var(--foreground);
    }

    .modal-header{
      border-bottom:0px;
    }
   
</style>